<template>
  <c-form @submit.prevent="submit">

    <c-grid>

      <c-grid-item :span="3">
        <c-form-input
          id="rating-code"
          :errors="[{
            message: 'Dieses Feld ist erforderlich.',
            show: !$v.ratingCode.required
          }]"
          :has-error="$v.ratingCode.$error"
          :is-valid="!$v.ratingCode.$invalid"
          v-model="ratingCode"
          aria-required="true"
          label="Bewertungscode"
          @input="$v.ratingCode.$touch"
        />
      </c-grid-item>

    </c-grid>

    <c-button :busy="status === $config.status.SAVING">
      Weiter
    </c-button>

  </c-form>
</template>

<script>
import CButton from '@/components/CButton'
import CForm from '@/components/form/CForm'
import CFormInput from '@/components/form/CFormInput'
import CFormRating from '@/components/form/CFormRating'
import CGrid from '@/components/CGrid'
import CGridItem from '@/components/CGridItem'

import handleRequestError from '@/functions/handleRequestError'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'CProjectRatingPrompt',

  components: {
    CButton,
    CForm,
    CFormInput,
    CFormRating,
    CGrid,
    CGridItem
  },

  props: {
    to: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      ratingCode: '',
      status: this.$config.status.IDLE
    }
  },

  validations: {
    ratingCode: {
      required
    }
  },

  methods: {
    submit () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$store.commit('notifications/add', {
          text: 'Bitte geben Sie einen Bewertungscode ein.',
          type: 'error'
        })

        return
      }

      this.status = this.$config.status.SAVING

      this.$api.get('projects/project/', {
        params: { rating_code: this.ratingCode }
      })
        .then(() => {
          this.$router.push({
            name: this.to,
            params: { ratingCode: this.ratingCode }
          })
        })
        .catch(error => {
          handleRequestError({
            error,
            fallback: 'Der eingegebene Bewertungscode ist leider nicht gültig.'
          })

          this.status = this.$config.status.ERROR
        })
    }
  }
}
</script>
